/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var NProgress = require('nprogress');
var _ = require('underscore');

var NavUtils = require('psa-core/util/nav');

var Scaffold = require('common/layout/Scaffold');

var GetExamDetailsForInternal = require('../../common/services/GetExamDetailsForInternal');
var GetExamDetailsForEntity = require('../../common/services/GetExamDetailsForEntity');

var NonDepInternalExamUpdateBillingDetailsView = require('../views/NonDepInternalExamUpdateExamResults');
var GetAllExamLookups = require('../../common/services/GetAllExamLookups');

module.exports = function(examId) {
  NProgress.start();
  NProgress.set(0.6);

  $.when(GetExamDetailsForInternal(examId), GetExamDetailsForEntity(examId), GetAllExamLookups()).done(function(
    internalDetails,
    entityDetails,
    examLookups
  ) {
    NavUtils.navigate('nondep/dashboard/exam/' + examId + '/update-exam-results');
    Scaffold.content.show(
      new NonDepInternalExamUpdateBillingDetailsView({
        model: new Backbone.Model({
          //might need externalDetails or entityDetails or examLookups examLookups, entityDetails
          exam: _.extend(entityDetails, internalDetails, examLookups)
        })
      })
    );
    NProgress.done();
  });
};
